export const terrainVectorTileConfig = {
  buildings: {
    id: "buildings",
    isDynamic: true,
    type: "vector",
    source: {
      type: "vector",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DISPLAY_BASEURL_V1}/buildings/tiles/{z}/{x}/{y}.pbf`,
      ],
      minzoom: 0,
      maxzoom: 22,
      promoteId: "id",
    },
    sourceId: "buildings",
    layers: [
      {
        id: "buildings-layer",
        type: "fill",
        source: "buildings",
        "source-layer": "buildings",
        minzoom: 0,
        paint: {
          "fill-color": "#888a8a",
          "fill-opacity": 1,
        },
      },
    ],
  },
};